"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var transform = exports.transform = {
  type: "select",
  options: [{ label: "Capitalize", value: "capitalize" }, { label: "Uppercase", value: "uppercase" }, { label: "Lowercase", value: "lowercase" }]
};
var fontWeight = exports.fontWeight = {
  type: "select",
  options: [{ label: "Light", value: "300" }, { label: "Normal", value: "400" }, { label: "Medium", value: "500" }, { label: "Bold", value: "600" }]
};

var iframeHeight = exports.iframeHeight = {
  type: "select",
  options: [{ label: "default", value: "350px" }, { label: "400px", value: "400px" }]
};
var contentAlign = exports.contentAlign = {
  type: "select",
  options: [{ label: "top", value: "flex-start" }, { label: "center", value: "center" }]
};

var columnPosition = exports.columnPosition = {
  type: "select",
  options: [{ label: "Default", value: "row" }, { label: "Rotate", value: "row-reverse" }]
};